import React, { useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';
import { ThemeContext } from 'styled-components';
import CustomCircularProgress from '../CustomizedComponents/CustomCircularProgress';

const showLoader = (data) => {
  return data?.some((item) => item === true);
};


const DefaultButton = (props) => {
  const { primary, title, loaders, ...other } = props;
  const themeContext = useContext(ThemeContext);
  const StyledButton = withStyles({
    root: {
      background: primary ?
        `${themeContext.buttons.backGroundColor.primaryColor}` :
        `${themeContext.buttons.backGroundColor.secondaryColor}`,
      color: primary ?
        `${themeContext.buttons.color.primaryColor}` :
        `${themeContext.buttons.color.secondaryColor}`,
      borderRadius: 3,
      border: 0,
      fontSize: '15.38px',
      letterSpacing: '1.25px',
      padding: '8px 16px',
      minWidth: '96px',
      marginRight: '10px',
      '&:hover': {
        background: primary ?
          `${themeContext.buttons.backGroundColor.primaryColor}` :
          `${themeContext.buttons.backGroundColor.secondaryColor}`,
      },
    },
  })(Button);

  return (
    <StyledButton {...other}>
      {showLoader(loaders) && <CustomCircularProgress primary={primary} size={15.38} />}
      <FormattedMessage id={String(title)} />
    </StyledButton>
  );
};

DefaultButton.propTypes = {
  primary: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.node,
  setEditable: PropTypes.func,
  editable: PropTypes.bool,
  handler: PropTypes.any,
  isNew: PropTypes.bool,
  idPanel: PropTypes.any,
  loaders: PropTypes.any,
};

export default (DefaultButton);
